module.exports = __webpack_public_path__ + "img/1571864436.6f6c82ab.jpg";